import { render, staticRenderFns } from "./modalX.vue?vue&type=template&id=265d59af"
import script from "./modalX.vue?vue&type=script&lang=js"
export * from "./modalX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports